















import { $store } from "@/store";
import { Vue, Component } from "vue-property-decorator";
import PdfPage from "./PdfPage.vue";

@Component({
  components: {
    "ag-pdf-page": PdfPage,
  },
})
export default class PdfViewer extends Vue {
  get elemHeight() {
    return $store.appearance.pdfViewerHeight;
  }

  get currentPage() {
    return $store.wizard.layoutPage;
  }

  get pdfViewerContainerPadding() {
    return $store.appearance.pdfViewerContainerPadding;
  }
}
